/**
 * Rótulos dos TIPOS DE DOCUMENTO ("Orçamento", "Ordem de serviço", ...).
 *
 * Fonte ÚNICA de propósito. O mapa vivia copiado em `NewQuotePage` e em
 * `QuoteDetailPage`, e a segunda cópia tinha só o rótulo curto — sem o gênero.
 * Quando o cabeçalho da tela de criação ("Total **do** orçamento" / "Total **da**
 * cotação") foi para a tela de edição, a saída óbvia era copiar o mapa uma
 * terceira vez, que é exatamente como os vocabulários de unidade divergiram
 * (CLAUDE.md #64).
 */

interface DocumentTypeLabel {
  /** Nome curto, do jeito que aparece no cabeçalho da tela. */
  short: string;
  /** Artigo definido: "o" orçamento, "a" cotação. */
  genderPrefix: 'o' | 'a';
}

const DOCUMENT_TYPE_LABELS: Record<string, DocumentTypeLabel> = {
  orcamento: { short: 'Orçamento', genderPrefix: 'o' },
  proposta_comercial: { short: 'Proposta comercial', genderPrefix: 'a' },
  cotacao: { short: 'Cotação', genderPrefix: 'a' },
  estimativa: { short: 'Estimativa', genderPrefix: 'a' },
  pedido: { short: 'Pedido de venda', genderPrefix: 'o' },
  ordem_servico: { short: 'Ordem de serviço', genderPrefix: 'a' },
  plano_trabalho: { short: 'Plano de trabalho', genderPrefix: 'o' },
  recibo: { short: 'Recibo', genderPrefix: 'o' },
  comprovante: { short: 'Comprovante', genderPrefix: 'o' },
};

/** Tipo desconhecido (documento legado, coluna nula) cai em "Orçamento". */
export const getDocumentTypeShortLabel = (docType: string): string =>
  DOCUMENT_TYPE_LABELS[docType]?.short || 'Orçamento';

export const getDocumentTypeGenderPrefix = (docType: string): 'o' | 'a' =>
  DOCUMENT_TYPE_LABELS[docType]?.genderPrefix || 'o';

/** "do orçamento" / "da cotação" — a contração pronta, que é como as telas usam. */
export const documentTypeOfLabel = (docType: string): string =>
  `${getDocumentTypeGenderPrefix(docType) === 'a' ? 'da' : 'do'} ${getDocumentTypeShortLabel(
    docType,
  ).toLowerCase()}`;
